"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFollowUp = exports.snoozeFollowUp = exports.rescheduleFollowup = exports.getResheduleReasons = exports.getFollowUpsUpcomingCount = exports.getFollowUpsOngoingCount = exports.getFollowUpsMissedCount = exports.getFollowUpsCount = exports.getFollowUps = exports.getFollowUpById = exports.deleteFollowUp = exports.defaultFollowUpData = exports.createFollowUp = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultFollowUpData = exports.defaultFollowUpData = {
  id: 0,
  enabled: true,
  leadId: null,
  assignedTo: null,
  transferredTo: null,
  agenda: '',
  comments: null,
  notes: null,
  assignedDate: null,
  dueDate: null,
  transferredTimestamp: null,
  priority: null,
  status: 'Pending',
  notifyClient: false,
  reminderDuration: null,
  isNextFollowupRequired: false,
  nextFollowupAssignedTo: null,
  nextFollowupAssignedDate: null,
  nextFollowupDueDate: null,
  snoozeTimestamp: [],
  rescheduleCount: 0,
  rescheduleTimestamp: [],
  assignedUser: null,
  isSuperAdminTask: false
};
const getFollowUps = params => (0, _request.default)({
  url: '/follow-ups',
  method: 'get',
  params
});
exports.getFollowUps = getFollowUps;
const getFollowUpById = id => (0, _request.default)({
  url: `/follow-ups/${id}`,
  method: 'get'
});
exports.getFollowUpById = getFollowUpById;
const updateFollowUp = (id, data) => (0, _request.default)({
  url: `/follow-ups/${id}`,
  method: 'patch',
  data
});
exports.updateFollowUp = updateFollowUp;
const deleteFollowUp = id => (0, _request.default)({
  url: `/follow-ups/${id}`,
  method: 'delete'
});
exports.deleteFollowUp = deleteFollowUp;
const createFollowUp = data => (0, _request.default)({
  url: '/follow-ups/',
  method: 'post',
  data
});
exports.createFollowUp = createFollowUp;
const snoozeFollowUp = (data, id = 0) => (0, _request.default)({
  url: '/follow-ups/snooze/',
  method: 'post',
  data
});
exports.snoozeFollowUp = snoozeFollowUp;
const rescheduleFollowup = data => (0, _request.default)({
  url: '/follow-ups/reschedule',
  method: 'post',
  data
});
exports.rescheduleFollowup = rescheduleFollowup;
const getResheduleReasons = params => (0, _request.default)({
  url: '/reasons',
  method: 'get',
  params
});
exports.getResheduleReasons = getResheduleReasons;
const getFollowUpsCount = params => (0, _request.default)({
  url: 'follow-ups/count',
  method: 'get',
  params
});
exports.getFollowUpsCount = getFollowUpsCount;
const getFollowUpsMissedCount = params => (0, _request.default)({
  url: 'follow-ups/missed-count',
  method: 'get',
  params
});
exports.getFollowUpsMissedCount = getFollowUpsMissedCount;
const getFollowUpsUpcomingCount = params => (0, _request.default)({
  url: 'follow-ups/upcoming-count',
  method: 'get',
  params
});
exports.getFollowUpsUpcomingCount = getFollowUpsUpcomingCount;
const getFollowUpsOngoingCount = params => (0, _request.default)({
  url: 'follow-ups/ongoing-count',
  method: 'get',
  params
});
exports.getFollowUpsOngoingCount = getFollowUpsOngoingCount;